var React = require('react');

function WishlistFilled (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m23.7 4.5c-.5-1.8-1.8-3.2-3.6-3.9-3.6-1.5-6.7.5-8.3 2.3-1.5-2.2-4.2-3.7-7.5-2.4-2.1.8-3.5 2.4-4.1 4.5-.6 2.2 0 4.7 1.3 6.6 2.4 3.2 9.4 9.4 9.7 9.7.2.2.4.3.7.3s.5 0 .7-.3c.3-.3 7.3-6.5 9.7-9.7 1.6-2.1 2-4.9 1.4-7.1z","fill":"#10642f","key":0}),React.createElement("path",{"d":"m20.4 10.4c-1.9 2.5-6.7 7.2-8.6 8.8-1.8-1.6-6.9-6.3-8.8-8.8-1.1-1.4-1.4-3.2-1-4.8.4-1.5 1.4-2.6 2.9-3.2.6-.3 1.2-.4 1.7-.4 2.4 0 3.8 2.3 4.2 3.1.3.7 1.5.7 1.8 0 .6-1.2 3.3-4.1 6.7-2.7 1.2.5 2.1 1.4 2.4 2.6.5 1.7 0 3.7-1.3 5.4z","fill":"#f6f0e9","key":1})]);
}

WishlistFilled.defaultProps = {"viewBox":"0 0 24 21.6"};

module.exports = WishlistFilled;

WishlistFilled.default = WishlistFilled;
